import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Clinics from "@/components/sections/Clinics";
import BookingForm from "@/components/sections/BookingForm";
import BlogPreview from "@/components/sections/BlogPreview";
import FAQ from "@/components/sections/FAQ";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-background text-foreground">
      <Navbar />
      <main id="contact">
        <Hero />
        <About />
        <Services />
        <Clinics />
        <BookingForm />
        <BlogPreview />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
